import {Card, Stack, Typography} from '@mui/material';
import React from 'react';
import {Colors} from '@constants/colors.constants';

interface InfosCardProps {
  menuOptions?: JSX.Element | JSX.Element[];
  onClick?: () => void;
  title?: string;
  unit?: string;
  value?: string | number;
}

const InfosCard = (props: InfosCardProps) => {
  const {
    menuOptions,
    onClick,
    title,
    unit,
    value,
  } = props;
  return (
    <Card
      onClick={onClick}
      sx={{cursor: onClick ? 'pointer' : undefined}}
      elevation={0}>
      <Stack p="10px" bgcolor={Colors.background} borderRadius="4px">
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={1} mr="-5px">
          <Typography noWrap fontSize={16} fontWeight="700">
            {title}
          </Typography>
          <Stack direction="row" alignItems="center">
            {menuOptions}
          </Stack>
        </Stack>
        <Stack direction="row" justifyContent="space-between">
          <Typography fontSize={14} color={Colors.textWithOpacity} fontWeight="400">{unit}</Typography>
          <Typography fontSize={14} color={Colors.textWithOpacity} fontWeight="400">{value}</Typography>
        </Stack>
      </Stack>
    </Card>
  );
};

export default InfosCard;
